module.exports = __webpack_public_path__ + "img/shape-metal_ag@2x.43827129.png";